import React from 'react';
import plusCircleLogo from 'assets/checkbox.svg';
import checkCircleLogo from 'assets/checkbox-checked.svg';
import styles from './styles.module.css';

const Medication = ({ med, updateBasket, basket }) => (
  <div
    tabIndex="0"
    onKeyPress={(event) =>
      med.can_be_requested && event.key === 'Enter' ? updateBasket(event, med.course_id, med.is_contraceptive) : null
    }
    onClick={med.can_be_requested ? (e) => updateBasket(e, med.course_id, med.is_contraceptive) : null}
    className={`${styles.box_container} ${med.can_be_requested ? null : styles.box_container__disabled}`}
    key={med.course_id}>
    <div className={`${styles.box_container__grid}`}>
      <div className={styles.image_container}>
        {med.can_be_requested ? (
          <img
            src={basket.includes(med.course_id) ? checkCircleLogo : plusCircleLogo}
            className={styles.plus_circle}
            alt="add to basket circle"
          />
        ) : null}
      </div>
      <div>
        <h3 className={`${styles.list_title} ${med.can_be_requested ? null : styles.list_title__disabled}`}>
          {med.name}
        </h3>
        <p className={`${styles.list_subtitle} ${med.can_be_requested ? null : styles.list_subtitle__disabled}`}>
          {med.dosage}
        </p>
      </div>
    </div>
  </div>
);

export default Medication;
